import React, { useState } from 'react';
import { Typography, Button, Menu, MenuItem } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import LanguageIcon from '@material-ui/icons/Language';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useIntl } from 'react-intl';
import { useLanguageContext } from './context';
import { Language } from './types';
import messages from './messages';
import options from './langs.json';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		buttonLabel: {
			[theme.breakpoints.down('sm')]: {
				display: 'none'
			}
		}
	})
);

const LanguageSwitcher: React.FC = () => {
	const classes = useStyles();
	const intl = useIntl();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const { language, setLanguage } = useLanguageContext();

	const handleMenuClick = (event: React.MouseEvent<HTMLElement>): void => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (): void => {
		setAnchorEl(null);
	};

	const handleSelection = (lang: Language): void => {
		handleClose();
		setLanguage(lang);
	};

	return (
		<div>
			<Button
				data-testid='language-switcher'
				aria-label='Language Switcher'
				variant='contained'
				color='primary'
				disableElevation
				startIcon={<LanguageIcon />}
				endIcon={<KeyboardArrowDownIcon />}
				onClick={handleMenuClick}>
				<Typography className={classes.buttonLabel} variant='button'>
					{intl.formatMessage({ ...messages[language.key] })}
				</Typography>
			</Button>
			<Menu
				data-testid='language-switcher-menu'
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				keepMounted
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
				open={open}
				onClose={handleClose}>
				{Object.values(options).map((lang: Language) => (
					<MenuItem key={lang.key} data-testid={`language-switcher-menu-${lang.key}`} onClick={(): void => handleSelection(lang)}>
						<Typography variant='button'>{intl.formatMessage({ ...messages[lang.key] })}</Typography>
					</MenuItem>
				))}
			</Menu>
		</div>
	);
};

export default LanguageSwitcher;
